var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1768 2.17678C15.2744 2.07915 15.2744 1.92085 15.1768 1.82322L13.5858 0.232233C13.4882 0.134602 13.3299 0.134602 13.2322 0.232233C13.1346 0.329864 13.1346 0.488155 13.2322 0.585786L14.6464 2L13.2322 3.41421C13.1346 3.51184 13.1346 3.67014 13.2322 3.76777C13.3299 3.8654 13.4882 3.8654 13.5858 3.76777L15.1768 2.17678ZM0 2.25H15V1.75H0V2.25Z",
    fill: "#2185D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowProfileIcon);
export default __webpack_public_path__ + "static/media/arrow-profile-icon.e5a61ea90f91fa475b11bcff2546371d.svg";
export { ForwardRef as ReactComponent };